/**
 * Cleans up an object by removing all keys with nullish values.
 * @param {Object} obj
 * @returns {Object}
 */
export default function compactObject(obj) {
  for (let p in obj) {
    if (obj[p] === null || obj[p] === undefined) { delete obj[p]; }
  }
  return obj;
}
